import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

type ContentTypeMode = 'singular' | 'plural';

@Pipe({
  name: 'contentType'
})
export class ContentTypePipe implements PipeTransform {

  constructor(private translate: TranslateService){}

  transform(value: string, mode: ContentTypeMode = 'singular'): string {
    const modeType = mode == 'singular' ? 'contentType' : 'contentTypes';
    const dictionaryKey = `${modeType}.${value}`;
    if (this.translate.instant(dictionaryKey) === dictionaryKey) {
      // key is not present. Avoid "contentType.X" or "contentTypes.Y" values
      return value;
    }
    return this.translate.instant(dictionaryKey);
  } 

}
